import { useState } from "react";
import { useGetsCobranzas } from "../endpoints";
import { patchCboRiesgo, patchCboAcciones, patchCboCanales, patchCboContactos, patchCboResultados, postCboRiesgo, postCboAcciones, postCboCanales, postCboContacto, postCboResultado, postCboArboGestion, patchCboArbolGestion, patchCboSiguienteGestion, postCboSiguienteGestion, patchCboEtapa, postCboEtapasGestion, patchCboFactoresComportamiento, postCboFactoresComportamiento, patchCboEstrategias, postCboEstrategias, postCboEstrategiasDetalle, patchCboEstrategiasDetalle, postCboScoringVariables, patchCboScoringVariables, patchCboScoringPesos, postCboScoringPesos, patchCboScoringRangos, postCboScoringRangos, patchCboconfigComportamiento, postCboConfigComportamiento } from "../endpoints";

const TABLE_NAMES = [
	{ key: "Cbo_Riesgo", label: "Riesgo" },
	{ key: "Cbo_Acciones", label: "Acciones" },
	{ key: "Cbo_Canales", label: "Canales" },
	{ key: "Cbo_Contactos", label: "Contactos" },
	{ key: "Cbo_Resultados", label: "Resultados" },
	{ key: "Cbo_ArbolGestion", label: "Árbol de Gestión" },
	{ key: "Cbo_SiguienteGestion", label: "Siguiente Gestión" },
	{ key: "Cbo_Etapas", label: "Etapas" },
	{ key: "Cbo_FactoresComportamiento", label: "Factores de Comportamiento" },
	{ key: "Cbo_Estrategias", label: "Estrategias" },
	{ key: "Cbo_EstrategiasDetalle", label: "Estrategias Detalle" },
	{ key: "Cbo_ScoringVariables", label: "Scoring Variable" },
	{ key: "Cbo_ScoringPesos", label: "Scoring Peso" },
	{ key: "Cbo_ScoringRangos", label: "Scoring Rangos" },
	{ key: "Cbo_ConfigComportamiento", label: "Config Comportamiento" },
];

export const Cobranza = () => {
	const [selected, setSelected] = useState(null);

	const [isModalOpen, setIsModalOpen] = useState(false);
	const [formData, setFormData] = useState(null);
	const [isEditing, setIsEditing] = useState(false);
	const [originalData, setOriginalData] = useState(null);


	const { riesgo, acciones, canales, contactos, resultados, arbol, siguiente, etapas, factores, estrategias, estrategiasDet, scoringVar, scoringPes, scoringRan, configComp, loading, error, refetch } =
		useGetsCobranzas();

	const TABLE_CONFIG = {
		Cbo_Riesgo: {
			data: riesgo,
			idKey: "sCbo_Riesgo",
			patch: (id, data) => patchCboRiesgo(id, data),
			post: (data) => postCboRiesgo(data),
			campos: [
				{ name: "Riesgo", label: "Nombre del Riesgo", type: "text", editable: true },
			]
		},
		Cbo_Acciones: {
			data: acciones,
			idKey: "sCbo_Acciones",
			patch: (id, data) => patchCboAcciones(id, data),
			post: (data) => postCboAcciones(data),
			campos: [
				{ name: "Accion", label: "Nombre de la Accion", type: "text", editable: true },
				{ name: "Activo", label: "Activo", type: "checkbox", editable: true },
			]
		},
		Cbo_Canales: {
			data: canales,
			idKey: "sCbo_Canales",
			patch: (id, data) => patchCboCanales(id, data),
			post: (data) => postCboCanales(data),
			campos: [
				{ name: "Canal", label: "Nombre del Canal", type: "text", editable: true },
				{ name: "InternoExterno", label: "Interno / Externo", type: "text", editable: true },
				{ name: "Activo", label: "Activo", type: "checkbox", editable: true },
			]
		},
		Cbo_Contactos: {
			data: contactos,
			idKey: "sCbo_Contactos",
			patch: (id, data) => patchCboContactos(id, data),
			post: (data) => postCboContacto(data),
			campos: [
				{ name: "Contacto", label: "Nombre del Contacto", type: "text", editable: true },
				{ name: "Activo", label: "Activo", type: "checkbox", editable: true },
			]
		},
		Cbo_Resultados: {
			data: resultados,
			idKey: "sCbo_Resultados",
			patch: (id, data) => patchCboResultados(id, data),
			post: (data) => postCboResultado(data),
			campos: [
				{ name: "Resultado", label: "Nombre del Resultado", type: "text", editable: true },
				{ name: "Activo", label: "Activo", type: "checkbox", editable: true },
			]
		},
		Cbo_ArbolGestion: {
			data: arbol,
			idKey: "sCbo_ArbolGestion",
			patch: (id, data) => patchCboArbolGestion(id, data),
			post: (data) => postCboArboGestion(data),
			campos: [
				{
					name: "idCanal", label: "Canal", type: "select", editable: true,
					options: canales.map(c => ({ value: c.idCanal, label: c.Canal }))
				},
				{
					name: "idContacto", label: "Contacto", type: "select", editable: true,
					options: contactos.map(c => ({ value: c.idContacto, label: c.Contacto }))
				},
				{
					name: "idResultado", label: "Resultado", type: "select", editable: true,
					options: resultados.map(r => ({ value: r.idResultado, label: r.Resultado }))
				},
				{ name: "Activo", label: "Activo", type: "checkbox", editable: true },

			]

		},
		Cbo_SiguienteGestion: {
			data: siguiente,
			idKey: "sCbo_SiguienteGestion",
			patch: (id, data) => patchCboSiguienteGestion(id, data),
			post: (data) => postCboSiguienteGestion(data),
			campos: [
				{
					name: "idArbolGestion",	label: "Árbol de Gestión", type: "select", editable: true,
					options: arbol.map(a => ({value: a.idArbolGestion, label: `${a.Canal} - ${a.Contacto} - ${a.Resultado}`}))
				},
				{
					name: "idAccion", label: "Accion", type: "select", editable: true,
					options: acciones.map(a => ({ value: a.idAccion, label: a.Accion }))
				},
				{
					name: "idCanal", label: "Canal", type: "select", editable: true,
					options: canales.map(c => ({ value: c.idCanal, label: c.Canal }))
				},
				{ name: "DiasProximaGestion", label: "Dias proxima Gestion", type: "number", editable: true },
				{ name: "Activo", label: "Activo", type: "checkbox", editable: true },
			]


		},
		Cbo_Etapas: {
			data: etapas,
			idKey: "sCbo_Etapas",
			patch: (id, data) => patchCboEtapa(id, data),
			post: (data) => postCboEtapasGestion(data),
			campos: [
				{ name: "Nombre", label: "Nombre", type: "text", editable: true },
				{ name: "MoraDesde", label: "Mora Desde", type: "number", editable: true },
				{ name: "MoraHasta", label: "Mora Hasta", type: "number", editable: true },
				{ name: "Nivel", label: "Nivel", type: "number", editable: true },
				{ name: "Activo", label: "Activo", type: "checkbox", editable: true },
			]
		},
		Cbo_FactoresComportamiento: {
			data: factores,
			idKey: "sCbo_FactoresComportamiento",
			patch: (id, data) => patchCboFactoresComportamiento(id, data),
			post: (data) => postCboFactoresComportamiento(data),
			campos: [
				{ name: "Nombre", label: "Nombre", type: "text", editable: true },
				{ name: "Activo", label: "Activo", type: "checkbox", editable: true },
			]
		},
		Cbo_Estrategias: {
			data: estrategias,
			idKey: "sCbo_Estrategias",
			patch: (id, data) => patchCboEstrategias(id, data),
			post: (data) => postCboEstrategias(data),
			campos: [
				{
					name: "idEtapa", label: "Etapa", type: "select", editable: true,
					options: etapas.map(e => ({ value: e.idEtapa, label: e.Nombre }))
				},
				{
					name: "idCbo_Riesgo", label: "Riesgo", type: "select", editable: true,
					options: riesgo.map(r => ({ value: r.idCbo_Riesgo, label: r.Riesgo }))
				},
				{ name: "Activo", label: "Activo", type: "checkbox", editable: true },
			]
		},
		Cbo_EstrategiasDetalle: {
			data: estrategiasDet,
			idKey: "sCbo_EstrategiasDetalle",
			patch: (id, data) => patchCboEstrategiasDetalle(id, data),
			post: (data) => postCboEstrategiasDetalle(data),
			campos: [
				{
					name: "idEstrategia",	label: "Estrategia", type: "select", editable: true,
					options: estrategias.map(e => ({value: e.idEstrategia, label: `${e.etapa} - ${e.riesgo}`}))
				},
				{
					name: "idAccion", label: "Accion", type: "select", editable: true,
					options: acciones.map(a => ({ value: a.idAccion, label: a.Accion }))
				},
				{
					name: "idCanal", label: "Canal", type: "select", editable: true,
					options: canales.map(c => ({ value: c.idCanal, label: c.Canal }))
				},
				{ name: "FrecuenciaDias", label: "Frecuencia Dias", type: "number", editable: true },
				{ name: "Intensidad", label: "Intensidad", type: "number", editable: true },
				{ name: "DiaInicio", label: "Dias Inicio", type: "number", editable: true },
				{ name: "PrioridadBase", label: "PrioridadBase", type: "number", editable: true },
				{ name: "Activo", label: "Activo", type: "checkbox", editable: true },
			]
		},
		Cbo_ScoringVariables: {
			data: scoringVar,
			idKey: "sCbo_ScoringVariables",
			patch: (id, data) => patchCboScoringVariables(id, data),
			post: (data) => postCboScoringVariables(data),
			campos: [
				{ name: "Codigo", label: "Codigo", type: "text", editable: true },
				{ name: "Nombre", label: "Nombre", type: "text", editable: true },
				{ name: "Activo", label: "Activo", type: "checkbox", editable: true },
			]
		},
		Cbo_ScoringPesos: {
			data: scoringPes,
			idKey: "sCbo_ScoringPesos",
			patch: (id, data) => patchCboScoringPesos(id, data),
			post: (data) => postCboScoringPesos(data),
			campos: [
				{
					name: "idVariable", label: "Scoring Variables", type: "select", editable: true,
					options: scoringVar.map(s => ({ value: s.idVariable, label: s.Nombre }))
				},
				{ name: "Peso", label: "Peso", type: "number", editable: true },
				{ name: "FechaInicio", label: "Fecha Inicio", type: "date", editable: true },
				{ name: "FechaFin", label: "Fecha Fin", type: "date", editable: true },
				{ name: "Activo", label: "Activo", type: "checkbox", editable: true },
			]
		},
		Cbo_ScoringRangos: {
			data: scoringRan,
			idKey: "sCbo_ScoringRangos",
			patch: (id, data) => patchCboScoringRangos(id, data),
			post: (data) => postCboScoringRangos(data),
			campos: [
				{
					name: "idVariable", label: "Scoring Variables", type: "select", editable: true,
					options: scoringVar.map(s => ({ value: s.idVariable, label: s.Nombre }))
				},
				{ name: "ValorDesde", label: "Valor Desde", type: "number", editable: true },
				{ name: "ValorHasta", label: "Valor Hasta", type: "number", editable: true },
				{ name: "ScoreAsignado", label: "Score Asignado", type: "number", editable: true },
				{ name: "Activo", label: "Activo", type: "checkbox", editable: true },
			]
		},
		Cbo_ConfigComportamiento: {
			data: configComp,
			idKey: "sCbo_ConfigComportamiento",
			patch: (id, data) => patchCboconfigComportamiento(id, data),
			post: (data) => postCboConfigComportamiento(data),
			campos: [
				{
					name: "idFactorComportamiento", label: "Factor Comportamiento", type: "select", editable: true,
					options: factores.map(f => ({ value: f.idFactorComportamiento, label: f.Nombre }))
				},
				{ name: "ValorDesde", label: "Valor Desde", type: "number", editable: true },
				{ name: "ValorHasta", label: "Valor Hasta", type: "number", editable: true },
				{ name: "ScoreImpacto", label: "Score Impacto", type: "number", editable: true },
				{ name: "Activo", label: "Activo", type: "checkbox", editable: true },
			]
		},
	};

	const currentData = TABLE_CONFIG[selected]?.data ?? [];
	const columns = currentData.length > 0 
	? Object.keys(currentData[0]).filter(col => !col.toLowerCase().startsWith("scbo"))
	: [];

	const handleNuevo = () => {
		if (!selected) return;
		setIsEditing(false);

		const config = TABLE_CONFIG[selected];

		const formVacio = {};

		config.campos.forEach(field => {

			if (field.type === "select" && field.options?.length > 0) {
				formVacio[field.name] = field.options[0].value;
			} else {
				formVacio[field.name] = "";
			}
		});


		setFormData(formVacio);
		setOriginalData(formVacio);
		setIsModalOpen(true);
	};

	const handleEditar = (row) => {
		if (!selected) return;
		setIsEditing(true);

		setFormData({ ...row });
		setOriginalData({ ...row });
		setIsModalOpen(true);
	};

	const handleGuardar = async () => {
		if (!selected || !formData) return;

		const config = TABLE_CONFIG[selected];

		try {
			if (isEditing) {
				const id = formData[config.idKey];

				const datosCambiados = {};

				Object.keys(formData).forEach((key) => {
					if (formData[key] !== originalData[key] && key !== config.idKey) {
						datosCambiados[key] = formData[key];
					}
				});

				if (Object.keys(datosCambiados).length === 0) {
					console.log("No se detectaron cambios.");
					setIsModalOpen(false);
					return;
				}

				console.log("Enviando solo modificaciones:", datosCambiados);
				await config.patch(id, datosCambiados);
				await refetch();
				console.log("Editado exitosamente");
			} else {
				await config.post(formData);
				await refetch();
				console.log("Creado exitosamente");
			}

			setIsModalOpen(false);
			setFormData(null);
			setOriginalData(null);

		} catch (error) {
			console.error("Error al guardar:", error);
		}
	};

	return (
		<div className="min-h-screen bg-white p-6 font-sans">
			<div
				className="flex border rounded-xl overflow-hidden"
				style={{ borderColor: "#e5e7eb", minHeight: "520px" }}
			>
				<div
					className="w-56 flex-shrink-0 border-r"
					style={{ background: "#f8f9ff", borderColor: "#e5e7eb" }}
				>
					<div className="px-4 py-4 border-b" style={{ borderColor: "#e5e7eb" }}>
						<p
							className="text-xs font-medium uppercase tracking-widest"
							style={{ color: "#6b7280" }}
						>
							Tablas
						</p>
					</div>
					{TABLE_NAMES.map(({ key, label }) => (
						<button
							key={key}
							onClick={() => setSelected(key)}
							className="w-full flex items-center gap-3 px-4 py-3 text-sm text-left border-b transition-colors"
							style={{
								borderColor: "#e5e7eb",
								background: selected === key ? "#2D3689" : "transparent",
								color: selected === key ? "#fff" : "#111827",
							}}
						>
							<span
								className="w-2 h-2 rounded-full flex-shrink-0"
								style={{ background: selected === key ? "#f97316" : "#c5c9f0" }}
							/>
							{label}
						</button>
					))}
				</div>

				<div className="flex flex-col flex-1">
					<div
						className="flex items-center justify-between px-6 py-4 border-b"
						style={{ borderColor: "#e5e7eb" }}
					>
						<div>
							<p className="text-base font-medium text-gray-900">
								{selected ? (TABLE_NAMES.find(t => t.key === selected)?.label ?? selected) : "Selecciona una tabla"}
							</p>
							<p className="text-xs text-gray-400 mt-0.5">
								{selected
									? `${currentData.length} registros`
									: "Elige una tabla del panel izquierdo"}
							</p>
						</div>
						<button
							onClick={handleNuevo}
							className="flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium text-white transition-colors"
							style={{ background: "#f97316" }}
							onMouseOver={(e) => (e.currentTarget.style.background = "#ea6c0a")}
							onMouseOut={(e) => (e.currentTarget.style.background = "#f97316")}
						>
							<span className="text-base leading-none">+</span>
							Nuevo
						</button>
					</div>

					{/* tablas */}
					<div className="flex-1 overflow-auto p-6">
						{loading && (
							<div className="flex items-center justify-center h-full text-sm text-gray-400">
								Cargando datos...
							</div>
						)}
						{error && (
							<div className="flex items-center justify-center h-full text-sm text-red-400">
								Error al cargar los datos.
							</div>
						)}

						{!loading && !error && !selected && (
							<div className="flex flex-col items-center justify-center h-full gap-3 text-gray-400">
								<div
									className="w-10 h-10 rounded-lg flex items-center justify-center"
									style={{ background: "#eef0ff" }}
								>
									<svg
										width="20"
										height="20"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#2D3689"
										strokeWidth="1.5"
									>
										<rect x="3" y="3" width="18" height="18" rx="3" />
										<path d="M3 9h18M9 21V9" />
									</svg>
								</div>
								<span className="text-sm">No hay tabla seleccionada</span>
							</div>
						)}

						{!loading && !error && selected && (
							<div className="overflow-x-auto">
								<table className="w-full text-sm border-collapse">
									<thead>
										<tr style={{ background: "#f8f9ff" }}>
											{columns.map((col) => (
												<th
													key={col}
													className="text-left px-4 py-2 text-xs font-medium uppercase tracking-wide whitespace-nowrap"
													style={{ color: "#2D3689", borderBottom: "1.5px solid #2D3689" }}
												>
													{col}
												</th>
											))}
											<th
												className="px-4 py-2 text-xs font-medium uppercase tracking-wide text-center"
												style={{
													color: "#2D3689",
													borderBottom: "1.5px solid #2D3689",
													width: "80px",
												}}
											>
												Acciones
											</th>
										</tr>
									</thead>
									<tbody>
										{currentData.map((row, rowIdx) => (
											<tr
												key={rowIdx}
												className="border-b transition-colors"
												style={{ borderColor: "#f3f4f6" }}
												onMouseOver={(e) => (e.currentTarget.style.background = "#f8f9ff")}
												onMouseOut={(e) => (e.currentTarget.style.background = "transparent")}
											>
												{columns.map((col) => (
													<td key={col} className="px-4 py-2 text-gray-800">
														{typeof row[col] === "boolean"
															? row[col] ? "Activo" : "Inactivo"
															: typeof row[col] === "object" && row[col] !== null
																? row[col].Nombre || row[col].Riesgo || Object.values(row[col])[1] || "—"
																: row[col] ?? "—"}
													</td>
												))}
												<td className="px-4 py-2 text-center">
													<button
														onClick={() => handleEditar(row)}
														className="px-3 py-1 text-xs rounded-md border transition-colors"
														style={{
															borderColor: "#2D3689",
															color: "#2D3689",
															background: "transparent",
														}}
														onMouseOver={(e) => {
															e.currentTarget.style.background = "#2D3689";
															e.currentTarget.style.color = "#fff";
														}}
														onMouseOut={(e) => {
															e.currentTarget.style.background = "transparent";
															e.currentTarget.style.color = "#2D3689";
														}}
													>
														Editar
													</button>
												</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
						)}
					</div>
				</div>
			</div>

			{/* modal */}
			{isModalOpen && (
				<div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
					<div className="bg-white rounded-xl shadow-lg w-full max-w-md p-6">
						<h3 className="text-lg font-bold mb-4" style={{ color: "#2D3689" }}>
							{isEditing ? `Editar ${TABLE_NAMES.find(t => t.key === selected)?.label ?? selected}` : `Nuevo ${TABLE_NAMES.find(t => t.key === selected)?.label ?? selected}`}
						</h3>

						<div className="flex flex-col gap-4 max-h-96 overflow-y-auto pr-2">
							{formData && TABLE_CONFIG[selected].campos.map((field) => {

								return (
									<div key={field.name}>
										<label className="block text-xs font-medium text-gray-700 mb-1">
											{field.label}
										</label>

										{field.type === "checkbox" ? (
											<input
												type="checkbox"
												disabled={!field.editable}
												checked={!!formData[field.name]}
												onChange={(e) => {
													setFormData({
														...formData,
														[field.name]: e.target.checked,
													});
												}}
												className="h-4 w-4"
											/>

										/* Si el tipo es SELECT, renderizamos un combobox */
										) : field.type === "select" ? (
											<select
												disabled={!field.editable}
												value={formData[field.name] ?? ""}
												onChange={(e) => {
													const val = isNaN(e.target.value) ? e.target.value : Number(e.target.value);
													setFormData({ ...formData, [field.name]: val });
												}}
												className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-orange-500 bg-white"
											>
												<option value="" disabled>Seleccione una opción</option>
												{field.options?.map(opt => (
													<option key={opt.value} value={opt.value}>
														{opt.label}
													</option>
												))}
											</select>
										) : (
											/* Si no es select, renderizamos un input de texto normal */
											<input
												type={field.type}
												disabled={!field.editable}
												value={formData[field.name] ?? ""}
												onChange={(e) => {
													let value = e.target.value;

													if (field.type === "number") {
														value = value === "" ? "" : Number(value); // 👈 clave
													}

													setFormData({
														...formData,
														[field.name]: value,
													});
												}}
												className={`w-full border rounded-lg px-3 py-2 text-sm focus:outline-none ${!field.editable
													? "bg-gray-100 text-gray-500 cursor-not-allowed"
													: "border-gray-300 focus:border-orange-500"
													}`}
											/>
										)}
									</div>
								);
							})}
						</div>

						<div className="flex justify-end gap-3 mt-6 pt-4 border-t" style={{ borderColor: "#e5e7eb" }}>
							<button
								onClick={() => setIsModalOpen(false)}
								className="px-4 py-2 text-sm font-medium text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
							>
								Cancelar
							</button>
							<button
								onClick={handleGuardar}
								className="px-4 py-2 text-sm font-medium text-white transition-colors rounded-lg"
								style={{ background: "#f97316" }}
								onMouseOver={(e) => (e.currentTarget.style.background = "#ea6c0a")}
								onMouseOut={(e) => (e.currentTarget.style.background = "#f97316")}
							>
								Guardar
							</button>
						</div>
					</div>
				</div>
			)}
			{/* fin modal */}
		</div>


	);
};